import React from 'react';
import styled from 'styled-components';
import ReportPercentage from '../ReportPercentage';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { beneficiariesTableGridStyles } from './ReportBeneficiariesHeader';
import { COLORS } from 'shared/design-system/settings/variables/Colors';

interface ReportBeneficiariesRowProps {
  category: string;
  groupName: string;
  subGroupName?: string;
  percentage: number | string;
}

const StyledDiv = styled.div`
  ${beneficiariesTableGridStyles}
  border-top: 1px solid ${COLORS.grayLight};
`;

const ReportBeneficiariesRow: React.FC<ReportBeneficiariesRowProps> = ({
  category,
  groupName,
  subGroupName,
  percentage,
}) => {
  return (
    <StyledDiv>
      <TrueImpactText variant="body-small">{category}</TrueImpactText>
      <TrueImpactText variant="body-small">{groupName}</TrueImpactText>
      <TrueImpactText variant="body-small">{subGroupName}</TrueImpactText>
      <TrueImpactText variant="body-small">
        <ReportPercentage backgroundColor="grayLight" percentage={percentage} />
      </TrueImpactText>
    </StyledDiv>
  );
};

export default ReportBeneficiariesRow;
